import { render } from "./FeiShuContractTemplate.vue?vue&type=template&id=6ff0f314&ts=true"
import script from "./FeiShuContractTemplate.vue?vue&type=script&lang=ts"
export * from "./FeiShuContractTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__